let uniqueIdCounter = 0;
function generateId(prefix = "") {
  const key = Math.random().toString(36).substr(2, 5);
  return `${key}${prefix}${++uniqueIdCounter}`;
}
export {
  generateId
};
//# sourceMappingURL=generate-random-id.js.map
